import { post } from "../../utils/Backend";
import {
  mockGetOrCreateConversation,
  mockListMessages,
  mockMarkRead,
  mockPollNewMessages,
  mockSendMessage,
} from "./CustomerServiceChatMock";
import type {
  CsConversationBootstrap,
  CsListMessagesResult,
  CsMessage,
  CsPollNewMessagesResult,
} from "./CustomerServiceChatTypes";

const mock = true;

const BASE = "/lark/app/customerService";

export const CustomerServiceChatApi = {
  async getOrCreateConversation(): Promise<CsConversationBootstrap | string> {
    if (mock && false) {
      return mockGetOrCreateConversation();
    }
    return post<Record<string, never>, CsConversationBootstrap>(
      `${BASE}/getOrCreateConversation`,
      {}
    );
  },

  async listMessages(
    conversationId: string,
    beforeMessageId?: string | null,
    size = 30
  ): Promise<CsListMessagesResult | string> {
    if (mock && false) {
      return mockListMessages(beforeMessageId);
    }
    return post<
      { conversationId: string; beforeMessageId?: string; size?: number },
      CsListMessagesResult
    >(`${BASE}/listMessages`, {
      conversationId,
      beforeMessageId: beforeMessageId ?? undefined,
      size,
    });
  },

  async pollNewMessages(
    conversationId: string,
    afterMessageId?: string | null
  ): Promise<CsPollNewMessagesResult | string> {
    if (mock && false) {
      return mockPollNewMessages(afterMessageId);
    }
    return post<
      { conversationId: string; afterMessageId?: string },
      CsPollNewMessagesResult
    >(`${BASE}/pollNewMessages`, {
      conversationId,
      afterMessageId: afterMessageId ?? undefined,
    });
  },

  async sendMessage(
    conversationId: string,
    content: string
  ): Promise<CsMessage | string> {
    if (mock && false) {
      return mockSendMessage(content);
    }
    return post<{ conversationId: string; content: string }, CsMessage>(
      `${BASE}/sendMessage`,
      { conversationId, content }
    );
  },

  async markRead(conversationId: string): Promise<boolean | string> {
    if (mock && false) {
      return mockMarkRead();
    }
    return post<{ conversationId: string }, boolean>(
      `${BASE}/markRead`,
      { conversationId }
    );
  },
};
